module.exports = __webpack_public_path__ + "img/Espiritualidad.4403039b.svg";